import React from 'react';

const Home = () => {
  return (
    <div>
      <main className="pageAside">
        <h2>Welcome to Homeless Resources</h2>
        
        <p>A national homeless resources database. Helping homeless people find the resources they need in the community that they live in. </p>
        
        <h2>The Mission</h2>
        
        <p>The mission of this site is simply to provide an online resource for people all over the country. A resource for people who may need food, shelter, a hot shower, or other assistance. Giving them the ability to find what they need in the area that they live in.</p>
      </main><aside>
        <h2>News</h2>
        <h3><a href="http://www.boston.com/news/local/massachusetts/2015/03/06/boston-homeless-rely-each-other-survive-record-winter/AfAX9KFpGQEd8UjvWsceAM/story.html">Boston's Homeless Rely on Each Other to Survive Record Winter</a></h3>
        <p>Shawn Grady, 44, lived in a sub-Saharan village in Africa for nearly three years with almost no money, but said it's more difficult to be homeless in ...</p>
        
        <h3><a href="http://www.lehighvalleylive.com/allentown/index.ssf/2015/03/fighting_for_the_rights_of_the.html">Fighting for the rights of the Allentown School District's homeless students</a></h3>
        <p>Russell &quot;Rooster&quot; Valentini has worked for the last 25 years as the district's homeless liaison.</p>
        
        <h3><a href="http://twentytwowords.com/homeless-people-each-share-one-thing-about-themselves-that-will-surprise-you/">Homeless People Each Share One Thing About Themselves That Will Surprise You</a></h3>
        <p>For a simple but profound project, Rethink Homelessness invited several of Orlando's homeless residents to tell the rest of us one fact from their lives that, if we walked past them, we would never expect.</p>
      </aside>
    </div>
  );
}

export default Home;